<div [class]="'app-section-outline-block ' + className + ' ' + theme">
  <div *ngIf="isShowFloatingTitle" class="app-section-outline-block__floating-title">
    <img class="app-section-outline-block__floating-title__icon" src="assets/images/document-upload-circled.svg" alt="upload" />
    <span class="app-section-outline-block__floating-title__text">
      {{ floatingTitle | translate }}
    </span>
  </div>

  <ng-content select="[section-header]"></ng-content>

  <div class="app-section-outline-block__header" [ngClass]="{ 'with-border': isShowHeaderBorder }">
    <p [class]="'app-section-outline-block__header__title ' + theme" [innerHTML]="headerTitle | translate"></p>
    <div class="app-section-outline-block__header__actions">
      <ng-content select="[section-header-actions]"></ng-content>
    </div>
  </div>

  <ng-content></ng-content>

  <ng-content select="[section-footer]"></ng-content>
</div>
